<template>
  <div :class="$style.videoWrapper" @click="hideModal">
    <div :class="$style.videoContainer" @click.stop>
      <button :class="$style.closeButton" @click="hideModal" aria-label="閉じる">×</button>
      <iframe
        :class="$style.videoIframe"
        :src="data.url"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'video-player',
  props: ['data'],
  mounted() {
    // ESCキーでモーダルを閉じる
    document.addEventListener('keydown', this.handleEscKey);
    // モーダル表示中はスクロールを無効化
    document.body.style.overflow = 'hidden';
  },
  beforeUnmount() {
    // イベントリスナーをクリーンアップ
    document.removeEventListener('keydown', this.handleEscKey);
    // スクロールを再度有効化
    document.body.style.overflow = '';
  },
  methods: {
    hideModal() {
      this.$store.dispatch('modal/contents/hideModal', null, { root: true });
    },
    handleEscKey(event) {
      if (event.key === 'Escape' || event.keyCode === 27) {
        this.hideModal();
      }
    },
  },
};
</script>

<style lang="scss" module>
.videoWrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.videoContainer {
  position: relative;
  width: 90%;
  max-width: 1000px;
  aspect-ratio: 16 / 9;
  cursor: default;

  @include sm-view {
    width: 95%;
  }
}

.videoIframe {
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

.closeButton {
  position: absolute;
  top: -40px;
  right: 0;
  background: transparent;
  border: none;
  color: white;
  font-size: 36px;
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  line-height: 1;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.2);
  }

  @include sm-view {
    top: -35px;
    font-size: 30px;
    width: 35px;
    height: 35px;
  }
}
</style>
